import Slider from "react-slick"
import "slick-carousel/slick/slick-theme.css"
import "slick-carousel/slick/slick.css"
import SlickCarouselArrow from "../../components/home/bannerComponents/SlickCarouselArrow/index"
import "./styles.css"

const SlickImageGallery = ({ items, customSettings }) => {
  if (!items.length === 0) return;

  const settings = {
    customPaging:
      items.length > 1
        ? (i) => <img src={items[i]} alt={items[i]} className="thumb-img" />
        : () => <div className="hidden" />,
    dots: items.length > 1,
    dotsClass: items.length > 1 ? "slick-dots slick-thumb" : "hidden",
    infinite: items.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    touchThreshold: 100,
    prevArrow: <SlickCarouselArrow side="left" />,
    nextArrow: <SlickCarouselArrow side="right" />,
    ...customSettings,
  }
  return (
    <div
      className={
        items.length <= 1 ? "gallery-slider" : "slider-container gallery-slider"
      }
    >
      <Slider {...settings}>
        {items?.map((item) => (
          <img key={item} src={item} alt={item} className="main-img" />
        ))}
      </Slider>
    </div>
  )
}

export default SlickImageGallery
